import axios from "axios";
import {API_URL} from "../utilities/variables"
import AuthInstance from "../utilities/auth";

const apiInstance = axios.create({baseURL:API_URL});
const getFiles = ['GetEstadoCuentaAlfin/','reporteExcel/']

apiInstance.interceptors.request.use(
    (request) =>{
    const url = request.url;
    if(getFiles.some(file => url.includes(file))) {
        request.responseType = 'blob';
    }
    //request.headers['X-API-Key'] = 'G6u9SxWH.sIhm3WuQKJnS7BKZbeGMOK4vHby33qtO';

    request.headers['Authorization'] = AuthInstance.getToken()

    return request;
    },
    (err) =>err

);

apiInstance.interceptors.response.use(
    (response)=>response,
    (err)=>{

        if (err.response && err.response.data.detail === 'Token inválido.') {
            localStorage.clear();
            window.location.href="./login"

        }
    
        else if(!err.response){
            return Promise.reject({
                status:404,
                timestamp:new Date(),
                message:"Se ha producido un error no contemplado",
                error:"Error de servidor"

            });
        }
        else if(!err.response.data){
            
                return Promise.reject({
                    status:404,
                    timestamp:new Date(),
                    message:"Se ha producido un error no contemplado",
                    error:"Error de servidor"
    
                });
        }
        
        return Promise.reject(err.response.data);
    }
)
export default apiInstance;